import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWRMutation from "swr/mutation";
const createCustomerLead = async (formData) => {
  return await jwtAxios.post(URL_API.CMS_CUSTOMER_LEADS.CREATE_CUSTOMER_LEAD, formData);
};

const useCreateCustomerLead = () => {
  const fetcher = (url, { arg }) => createCustomerLead(arg);
  return useSWRMutation(URL_API.CMS_CUSTOMER_LEADS.CREATE_CUSTOMER_LEAD, fetcher);
};

export default useCreateCustomerLead;
